var _circle, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleDrive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1425 15.9167C15.9539 16.2525 16.0375 16.5234 15.7213 16.71C15.4051 16.8971 15.041 17 14.6621 17H7.33787C6.95932 17 6.59557 16.8971 6.27906 16.7104C5.96254 16.5237 6.04608 16.2525 5.85751 15.9167L8.56093 12.6667H13.4391L16.1425 15.9167Z",
    fill: "#1E88E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2206 4.36074C12.5988 4.36002 12.9622 4.10218 13.2784 4.28924C13.5945 4.47666 13.8634 4.74785 14.0527 5.08404L17.7149 11.5826C17.9041 11.9184 17.9993 12.2929 17.9997 12.6667C18 13.0411 17.5531 13.4152 17.3631 13.7503L13.4412 12.6652L11.0007 8.3344L12.2206 4.36074Z",
    fill: "#FBC02D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.6667C18 13.0422 17.9048 13.4142 17.7145 13.75L16.4209 16.0431C16.2341 16.3247 15.9945 16.5486 15.7195 16.7111L13.4391 12.6667H18Z",
    fill: "#E53935"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.63692 13.7504C4.44729 13.4152 4.00036 13.0411 4.00036 12.667C4.00072 12.2929 4.09553 11.9184 4.28516 11.5822L7.94729 5.08369C8.13657 4.74785 8.4055 4.4763 8.72131 4.28924C9.03747 4.10183 9.40122 4.35966 9.77942 4.36038L10.9986 8.33585L8.55882 12.6652L4.63692 13.7504Z",
    fill: "#4CAF50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56093 12.6667L6.28046 16.7111C6.00554 16.5486 5.76586 16.3247 5.57905 16.043L4.2855 13.75C4.09517 13.4142 4 13.0422 4 12.6667H8.56093Z",
    fill: "#1565C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2769 4.28889L11 8.33333L8.71954 4.28889C8.99446 4.12639 9.30463 4.02528 9.63595 4.00361L12.2195 4C12.6002 4 12.9632 4.10111 13.2769 4.28889Z",
    fill: "#2E7D32"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDrive);
export default __webpack_public_path__ + "static/media/GoogleDrive.1e10d78c0467d8f40ad3548dcda48295.svg";
export { ForwardRef as ReactComponent };